export default "/images/decrease.svg"